import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import PhoneInTalkIcon from '@mui/icons-material/Call';
import PhoneMissedIcon from '@mui/icons-material/PhoneMissed';
import { FullSizeFlexBox } from '../../../../Components/FlexBox';

const ResponseToggleButton = function ResponseToggleButton({
  answered,
  handleChangeAnswered,
  disableAnsweredButtons,
}) {
  const intl = useIntl();

  //when disabled the buttons act as read-only status indicators (state set by the call update)
  const answeredBg = answered ? 'success.light' : 'transparent';
  const notAnsweredBg = answered === false ? 'error.main' : 'transparent';

  const readOnlySx = (active, restingBg) =>
    disableAnsweredButtons
      ? {
          cursor: 'not-allowed',
          boxShadow: 'none',
          opacity: active ? 1 : 0.4,
          '&:hover': {
            backgroundColor: restingBg,
            boxShadow: 'none',
          },
        }
      : {};

  return (
    <FullSizeFlexBox gap="8px">
      <Button
        onClick={() => !disableAnsweredButtons && handleChangeAnswered(true)}
        disableRipple={disableAnsweredButtons}
        variant={answered ? 'contained' : 'outlined'}
        aria-label="answered call"
        color={answered ? 'success' : 'white'}
        startIcon={<PhoneInTalkIcon />}
        sx={{
          width: '50%',
          borderRadius: '18px',
          borderWidth: '3px',
          textTransform: 'none',
          fontSize: '1.2rem',
          fontWeight: 500,
          backgroundColor: answered && 'success.light',
          ...readOnlySx(answered === true, answeredBg),
        }}
      >
        {intl.messages.ANSWERED}
      </Button>
      <Button
        onClick={() => !disableAnsweredButtons && handleChangeAnswered(false)}
        disableRipple={disableAnsweredButtons}
        variant={answered === false ? 'contained' : 'outlined'}
        aria-label="not answered call"
        color={answered === false ? 'error' : 'white'}
        startIcon={<PhoneMissedIcon />}
        sx={{
          width: '50%',
          borderRadius: '18px',
          borderWidth: '3px',
          textTransform: 'none',
          fontSize: '1.2rem',
          fontWeight: 500,
          ...readOnlySx(answered === false, notAnsweredBg),
        }}
      >
        {intl.messages.NOT_ANSWERED}
      </Button>
    </FullSizeFlexBox>
  );
};

ResponseToggleButton.propTypes = {
  answered: PropTypes.bool,
  handleChangeAnswered: PropTypes.func,
};

export default ResponseToggleButton;
